(() => {
  angular
    .module('gm.common.directives')
    .directive('gmPadInput', gmPadInputDirective);

  function gmPadInputDirective() {
    'ngInject';

    return {
      require: 'ngModel',
      restrict: 'A',
      link(scope, element, attrs, ctrl) {
        function blurHandler() {
          const inputPaddingLength = attrs.gmPadInput;
          const viewValueLength = (ctrl.$viewValue.toString()).length;

          if (ctrl.$viewValue && (viewValueLength < inputPaddingLength
            && ctrl.$viewValue.toString() !== '0')) {
            let viewValue = ctrl.$viewValue;

            for (let i = viewValueLength; i < inputPaddingLength; i += 1) {
              viewValue = `0${viewValue}`;
            }
            ctrl.$setViewValue(viewValue);
            ctrl.$render();
          }
        }

        attrs.gmPadInput = attrs.gmPadInput || 2;

        element.on('blur', blurHandler);

        scope.$on('$destroy', () => {
          element.off('blur', blurHandler);
        });
      },
    };
  }
})();
